import styled from "styled-components";

export const StyledForm = styled.form``;

export const StyledWrapper = styled.div`
  margin-top: 36px;

  .cashout-details {
    ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopyBold}
    line-height: 20px;
    text-align: right;

    .value {
      ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopy}
      line-height: 20px;
    }
  }

  .cashout-heading {
    margin-bottom: 16px;
    height: 40px;
    display: flex;
    justify-content: space-between;

    h1 {
      color: ${({ theme }) => theme.colors.neutralsText};
      ${({ theme }) => theme.fontStyles.DesktopHeadlinesH3}
    }
  }

  .cashout-items {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;
